<template>
  <el-row v-if="type==='MakeForm'" :gutter="data.setting.gutter" class="he-layout--row">
    <div class="he-layout--row--tip">列数: {{ data.setting.col }}, 间距: {{ data.setting.gutter }}</div>
    <draggable
      v-model="data.setting.colList"
      chosen-class="ghost"
      class="he-layout--content-inner--draggable"
      group="HFormGroup"
      animation="300"
      @add="filterList"
      @update="filterList"
    >
      <el-col v-for="(item, index) in data.setting.colList" :key="index" :span="Math.floor(24 / data.setting.col)" class="he-layout--col__make">
        <which-element v-if="data.setting.colList[index]" :type="type" :data="data.setting.colList[index]" @delete="filterList" @click.native.stop="clickComponent(data.setting.colList[index])">
          <template slot-scope="{itemData, itemModel}">
            <slot :layoutData="itemData" :layoutModel="itemModel" />
          </template>
        </which-element>
      </el-col>
    </draggable>
  </el-row>
  <el-row v-else :gutter="data.setting.gutter" class="he-layout--row">
    <el-col v-for="(item, index) in data.setting.colList" :key="index" :span="Math.floor(24 / data.setting.col)" class="he-layout--col__show">
      <which-element v-if="data.setting.colList[index]" :type="type" :data="data.setting.colList[index]" :model="model" :prop="data.setting.colList[index].fieldId">
        <template slot-scope="{itemData, itemModel}">
          <slot :layoutData="itemData" :layoutModel="itemModel" />
        </template>
      </which-element>
      <el-col v-else :offset="Math.floor(24 / data.setting.col)" />
    </el-col>
  </el-row>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'HLayout',
  components: { draggable },
   inject: {
    formData: {
      default: () => {}
    },
    contentSelectChange: {
      default: () => () => {}
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    model: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
    }
  },
  watch: {
    'data.setting.col'(val) {
      this.filterList()
    }
  },
  created() {
    if (!this.data.setting.colList?.length) {
      this.data.setting.colList = new Array(this.data.setting.col)
    }
  },
  methods: {
    filterList() {
      const list = this.data.setting.colList
      for (let index = list.length - 1; index > 0; index--) {
        if (!list[index]) {
          list.pop()
        } else {
          break
        }
      }
      if (this.data.setting.col > list.length) {
        list.push(...new Array(this.data.setting.col - list.length))
        this.data.setting.colList = list
      }
    },
    clickComponent(item) {
      this.formData.formDataList.forEach(f => {
        f.makeStyle.active = false
      })
      this.data.setting.colList.forEach(f => {
        if (!f) {
          // 暂未逻辑
        } else if (f === item) f.makeStyle.active = true
        else f.makeStyle.active = false
      })
      typeof this.contentSelectChange === 'function' && this.contentSelectChange(item)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../index.scss';
.ghost{
  height: 80px;
}
.he-layout {
  &--row {
    &--tip {
      width: 100%;
      font-size: 12px;
      line-height: 20px;
    }
  }
  &--col {
    &__make {
      height: 80px;
      overflow: hidden;
      // height: 100%;
      border: 1px dashed #ccc;
      box-sizing: border-box;
    }
    &__show {
      min-height: 36px;
      box-sizing: border-box;
      margin-bottom: 10px;
    }
  }
  &--content-inner--draggable{
    width: 100%;
    height: 100%;
  }
}
</style>
